import { Email as EmailIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import isEmpty from "lodash/isEmpty";
import type { FC } from "react";
import type { ID } from "../../data/BaseEntity";
import { sendEmail } from "../../misc/sendEmail";
import { useCustomerEmailTemplates } from "./useCustomerEmailTemplates";
interface Props {
  readonly customerId: ID;
  readonly calculationId: ID;
  readonly calculationName: string;
}

const CalculationEmailButton: FC<Props> = ({ customerId, calculationId, calculationName }) => {
  const { templates } = useCustomerEmailTemplates(calculationId, customerId, calculationName);
  const disabled = isEmpty(templates);
  return (
    <Button
      variant="outlined"
      color="secondary"
      disabled={disabled}
      startIcon={<EmailIcon />}
      onClick={() => {
        sendEmail(templates[0].template);
      }}
    >
      Email
    </Button>
  );
};

export default CalculationEmailButton;
